import { render, staticRenderFns } from "./OrderStatusChangePopup.vue?vue&type=template&id=531f50f6&scoped=true&"
import script from "./OrderStatusChangePopup.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChangePopup.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusChangePopup.vue?vue&type=style&index=0&id=531f50f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f50f6",
  null
  
)

export default component.exports